module.exports = __webpack_public_path__ + "static/media/java-og.89fe77f6.svg";